import { IRoles } from "../../components/mosaic/Roles/interface";
import {
  ApiResponse,
  ICreateUpdateRole,
  IPermissionByCompanyIdResponse,
  PermissionRequestBody,
  PermissionsResponse,
} from "./interface";
import { axiosInstanceAuth } from "./setup";

export const handleGetPermissionByCompanyIdApi = async (
  companyId: number
): Promise<IPermissionByCompanyIdResponse[]> => {
  const result = await axiosInstanceAuth().get(`/admin/permission_by_company/${companyId}`);
  return result.data;
};

export const handleCreateRolesApi = async (formData: ICreateUpdateRole) => {
  const result = await axiosInstanceAuth().post(`/admin/create_role`, formData);
  return result.data;
};

export const handleUpdateRolesApi = async (formData: ICreateUpdateRole) => {
  const result = await axiosInstanceAuth().put(`/admin/update_role`, formData);
  return result.data;
};

export const handleGetPermissionsApi = async (): Promise<PermissionsResponse[]> => {
  const result = await axiosInstanceAuth().get(`/admin/permissions`);
  return result.data;
};

export const handleCreatePermissionsApi = async (
  formData: PermissionRequestBody
): Promise<PermissionsResponse[]> => {
  const result = await axiosInstanceAuth().post(`/admin/permission`, formData);
  return result.data;
};

export const handleUpdatePermissionsApi = async (
  formData: PermissionRequestBody,
  permissionId: number
): Promise<PermissionsResponse[]> => {
  const result = await axiosInstanceAuth().put(`/admin/permission/${permissionId}`, formData);
  return result.data;
};

export const handleGetRoles = async (): Promise<IRoles[]> => {
  const result = await axiosInstanceAuth().get<ApiResponse>(`/admin/fetch_roles`);
  return result.data.data as IRoles[];
};

export const handleGetRolesByCompanyIdApi = async (
  companyId: number
): Promise<IRoles[]> => {
  const result = await axiosInstanceAuth().get<ApiResponse>(`/admin/roles_by_company?companyId=${companyId}`);
  return result.data.data as IRoles[];
};

export const handleDeletePermission = async (id: number) => {
  return axiosInstanceAuth().delete("/admin/delete_permission", { data: { id } });
};
